const host = window.location.host;

const match = host.match(/(branas|kungsberget|vallasen|ulricehamn|uc|tolvmannabacken|storstenshojden|brf-bgb)/);

if (match && match[0] === 'uc') {
  match[0] = 'ulricehamn';
}

if (match && match[0] === 'brf-bgb') {
  match[0] = 'branas';
}

if (match) {
  window.SITE_BRANDING = match[0];
}

if (!window.SITE_BRANDING) {
  console.error('No matching site!');
}

export const theFunction = () => {
};

export default theFunction;



// WEBPACK FOOTER //
// ./src/lib/calculate-on-site-url.js